import React, { useMemo } from 'react';
import traverse from 'traverse';

const escapeJsonLdString = string =>
  JSON.stringify(string).replace(/(^"|"$)/g, '');

export const withJsonLdEscaping = Component => {
  return props => {
    const clean = useMemo(() => {
      return traverse(props).map(function (value) {
        if (typeof value === 'string') {
          value ? this.update(escapeJsonLdString(value)) : this.remove();
        }
      });
    }, [props]);

    return <Component {...clean} />;
  };
};
